export const SMS_AI_TONE_OPTIONS = [
  'Formal',
  'Casual',
  'Friendly',
  'Persuasive',
  'Urgent',
  'Apologetic',
];

export const SMS_AI_PROMPT_PLACEHOLDER =
  "e.g. Send a friendly appointment reminder for tomorrow's consultation, a promotional offer for our spring sale, or a personalized follow-up for customers who attended last week's webinar";

export const SMS_AI_HELPER_TEXT =
  'Be specific about details like purpose, audience, and desired outcome to get the best results';

export const SMS_AI_ERROR_MESSAGE =
  'AI could not generate the SMS. Please try again.';

export function canGenerateSms(prompt) {
  return Boolean((prompt || '').trim());
}

export function canUseGeneratedSms(message) {
  return Boolean((message || '').trim());
}

function summarizePrompt(prompt) {
  const trimmed = (prompt || '').trim();
  if (!trimmed) return 'your request';
  if (trimmed.length <= 90) return trimmed;
  return `${trimmed.slice(0, 87)}...`;
}

/** Local fallback when no write-sms API is available. */
export function generateSmsFallback(tone = 'Friendly', prompt = '') {
  const summary = summarizePrompt(prompt);
  const templates = {
    Formal: `Hello, this is a reminder regarding ${summary}. Please reply if you have any questions.`,
    Casual: `Hey! Quick note about ${summary}. Text back if you need anything.`,
    Friendly: `Hi! Just a friendly reminder: ${summary}. Let us know if you need help.`,
    Persuasive: `Don't miss out: ${summary}. Reply YES to learn more.`,
    Urgent: `Important: ${summary}. Please respond as soon as possible.`,
    Apologetic: `We're sorry for the inconvenience. ${summary}. Thank you for your patience.`,
  };
  return templates[tone] || templates.Friendly;
}

export function buildWriteSmsPayload({
  tone,
  prompt,
  workflowId,
  stepId,
  existingMessage,
}) {
  return {
    tone,
    prompt: (prompt || '').trim(),
    context: {
      workflow_id: workflowId || null,
      step_id: stepId || null,
      existing_message: existingMessage || '',
    },
  };
}
